<style lang="less" scoped>
.menuItem{min-width: 100px;}
.menu_icon{width: 16px;}
</style>

<template>
  <!-- <v-contextmenu :ref="ref" :theme="theme">
    <template v-for="grpFuncs in menuData">
      <template v-for="func in grpFuncs">
        <v-contextmenu-item v-if="func.divider" divider class="menuItem" :key="func.name"></v-contextmenu-item>
        <v-contextmenu-item v-else
           class="menuItem"
          :key="func.name"
          :disabled="func.disabled"
          :autoHide="autoHide"
          :attrs="func"
          @click="onClick">
            <i :class="func.icon"></i>
            <span>{{func.name}}</span>
        </v-contextmenu-item>
      </template>
    </template>
  </v-contextmenu> -->
  <div></div>
</template>

<script>
/* 组件-右键菜单 */
export default
{
  props:
  {
    theme: String,              //主题。可选值 default / bright
    func: {type: Array, required: true},
    funcgrp: {type: Array, required: true},
    params: Object             // 额外自定义参数
  },
  data()
  {
    let data =
    {
      ref: 'cmenu',                  //VContextmenu 的实例名
      autoHide: true,
      menuData: {},                  //最终显示的菜单数据
      commonFuncs: [],               //系统缺省菜单
      entityFuncs: {}                //实体菜单，按grp分组
    }
    cx.base.extend(data, this.params)
    return data
  },
  created()
  {
    this.init()
  },
  methods:
  {
    init()
    {
      this.curEtt = null                     //传入的实体对象
      this._CommDefDispOrder = 1             //通用菜单组的disporder
      this._EntityDispOrder = 2              //实体菜单组的disporder
      this._ConstContextMenu = 'contextmenu' //右键菜单组的target值
      for (let grp of this.funcgrp)
      {
        if (grp.target === this._ConstContextMenu)
        {
          for (let func of this.func)
          {
            if (func.grp === grp.name)
            {
              func = cx.base.extend({name: cx.base.locale(func.namec, func.namee)}, func)
              if (grp.disporder === this._CommDefDispOrder)
              {
                //通用菜单
                this.commonFuncs.push(func)
              }
              else
              {
                //实体菜单
                this.entityFuncs[grp.name] = this.entityFuncs[grp.name] || []
                this.entityFuncs[grp.name].push(func)
              }
            }
          }
        }
      }
    },
    /**
     * 添加公共右键菜单（系统）
     * @method
     */
    addComm()
    {
      this.addCustom(this.commonFuncs)
    },
    /**
     * 添加自定义右键菜单项
     * @method
     * @param {Array.<Object>}	menus		               自定义菜单数据对象序列，同一个序列的菜单必须同组
     * @param {Object}          menus.func             菜单数据项
     * @param {String}          menus.func.grp         菜单所属的组名
     * @param {String}          menus.func.name        菜单项的文本名
     * @param {Boolean}         [menus.func.disabled]  是否禁用菜单项
     * @param {String}          [menus.func.icon]      菜单项的图片名
     * @param {String}          [menus.func.plugin]    菜单项响应的插件名
     * @param {Function}        [menus.func.callback]  菜单项的响应函数
     */
    addCustom(menus = [])
    {
      let data = this.copyObject(this.menuData)
      if (menus.length > 0)
      {
        let grp = menus[0].grp
        data[grp] = data[grp] || []
        //已有菜单项 且 改组没有分隔条
        if (this.isExistItem() && !cx.array.get1(data[grp], {divider: true}))
          data[grp].push({divider: true, name: grp})
        for (let func of menus)
        {
          if (!func.plugin || (func.plugin))
            data[grp].push(func)
        }
        this.menuData = data
      }
    },
    /**
     * 根据实体数据，为实体对象添加特有的菜单项
     * @method
     * @param {Object} data            选中对象的数据
     * @param {Number} data.major      选中对象的主类型
     * @param {Number} data.minor      选中对象的子类型
     * @param {Number} data.id         选中对象的id
     * @param {Object} [data.target]   选中对象的原始数据
     */
    addEntityByEtt(data)
    {
      // eslint-disable-next-line no-undef
      let ett = $g.entity.byMajMin(data.major, data.minor)
      if (ett && cx.base.isObj(ett.func))
      {
        //entity表的func配置了实体菜单
        if (cx.base.isArr(ett.func.cmenu))
          this.addEntityByGrps(ett.func.cmenu)
      }
      else if (data.target.attributes && data.target.attributes.menugrp)
      {
        //实体树节点数据对象
        this.addEntityByGrps([data.target.attributes.menugrp])
      }
      else
      {
        //选中对象没有右键菜单时，使用默认公共右键菜单
        this.addComm()
      }
    },
    /**
     * 根据菜单组，为实体对象添加特有的菜单项
     * @method
     * @param {Array.<String>} grps 菜单组名序列
     */
    addEntityByGrps(grps)
    {
      for (let grp of grps)
        this.addCustom(this.entityFuncs[grp])
    },
    /**
     * 清空右键菜单的全部内容
     * @method
     */
    clear()
    {
      this.curEtt = null
      this.menuData = {}
    },
    copyObject(obj)
    {
      return JSON.parse(JSON.stringify(obj))
    },
    /**
     * 清空右键菜单的系统公共菜单
     * @method
     */
    clearComm()
    {
      let data = this.copyObject(this.menuData)

      if (this.commonFuncs[0])
        delete data[this.commonFuncs[0].grp]
        
      this.menuData = data
    },
    /**
     * 隐藏菜单
     * @method
     */
    // hide()
    // {
    //   if (this.$refs[this.ref])
    //     this.$refs[this.ref].hide()
    // },
    /**
     * 判断是否已经存在菜单项
     * @method
     * @returns {Boolean} 判断的结果
     */
    isExistItem()
    {
      for (let key in this.menuData)
      {
        if (this.menuData[key].length > 0)
          return true
      }
      return false
    },
    /**
     * 菜单点击事件
     * @method
     * @param {Object}  vm    当前选中菜单的实例
     * @param {Object}  event 当前选中菜单的event
     */
    onClick(vm, event)
    {
      let data = vm.$attrs.attrs
      if (cx.base.isFunc(data.callback))
        data.callback()
      else if (data.plugin)
      {
        if (this.curEtt && this.curEtt.funcOpts && this.curEtt.funcOpts[data.plugin])
          cx.run.runPlug(data.plugin, this.curEtt.funcOpts[data.plugin])
        else
          cx.run.runPlug(data.plugin, this.curEtt)
      }
    },
    /**
     * 删除菜单项
     * @method
     * @param {Object}   func             菜单数据项
     * @param {String}   func.grp         菜单所属的组名
     * @param {String}   func.name        菜单项的文本名
     */
    remove(func)
    {
      let data = this.copyObject(this.menuData)
      for (let i = 1; i < data[func.grp].length; i++)
      {
        let _func = data[func.grp][i]
        if (_func.name === func.name)
          data[func.grp].splice(i, 1)
      }
      this.menuData = data
    },
    /**
     * 根据实体数据，删除特有的菜单项
     * @method
     * @param {Object} data           选中对象的数据
     * @param {Number} data.major     选中对象的主类型
     * @param {Number} data.minor     选中对象的子类型
     * @param {Number} data.id        选中对象的id
     * @param {Object} [data.target]  选中对象的原始数据
     */
    removeByEtt(data)
    {
      // eslint-disable-next-line no-undef
      let ett = $g.entity.byMajMin(data.major, data.minor)
      if (ett && cx.base.isObj(ett.func))
      {
        if (cx.base.isArr(ett.func.cmenu))
          this.removeByGrps(ett.func.cmenu)
      }
      else if (data.target.attributes && data.target.attributes.menugrp)
        this.removeByGrps([data.target.attributes.menugrp])
      else
      {
        //选中对象没有右键菜单时，清除默认公共右键菜单
        this.clearComm()
      }
    },
    /**
     * 根据菜单组，删除右键菜单
     * @method
     * @param {Array.<String>} grps 菜单组名序列
     */
    removeByGrps(grps)
    {
      let data = this.copyObject(this.menuData)
      for (let grp of grps)
        delete data[grp]
        
      this.menuData = data
    },
    /**
     * 显示菜单
     * @method
     * @param {Object}  position        菜单显示位置坐标
     * @param {Number}  position.top    菜单位置纵坐标
     * @param {Number}  position.left   菜单位置横坐标
     * @param {Object}  ett             选中对象的数据
     * @param {Number}  ett.major       选中对象的主类型
     * @param {Number}  ett.minor       选中对象的子类型
     * @param {Number}  ett.id          选中对象的id
     * @param {Object}  ett.target      选中对象的原始数据
     * @param {Object}  [ett.funcOpts]  各右键菜单对应的插件和初始化参数的对象列表对象
     */
    show(position, ett)
    {
      this.curEtt = ett
      if (this.$refs[this.ref])
        this.$refs[this.ref].show(position)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/com/ContextMenu.vue